import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Drawer } from "ant-design-vue";
import { QuickViewDrawerProps, QuickViewProps } from "./interface";
import QuickView from "@/components/quick-view/quick-view.vue";
import { CommonLocale } from "@/locales/localeid";
import { QuickViewWindowType } from "@/util/enum";
import { QuickViewContentModel, QuickViewExposureModel, QuickViewWindowService } from "@/services/quick-view-window";
import { MessageHelper, NotificationType, fmtMsg, isGuid } from "commonui";
import { isUndefined, isNull } from "lodash";

@Component({
	components: {
		Drawer,
		QuickView
	}
})
export default class QuickViewDrawer extends Vue {
	@Prop({ default: () => {} }) drawerProps: QuickViewDrawerProps | undefined;
	@Prop({ default: () => {} }) quickViewProps: QuickViewProps | undefined;
	public loading: boolean = false;
	public contentData: QuickViewContentModel | null = null;
	public exposurData: QuickViewExposureModel | null = null;
	public title: string = this.localizedString(this.commonLocales.CommonQuickViewTitle);

	@Watch("drawerProps")
	onPropChanged() {
		// Similar to activeKey = activeKey.concat(defaultActiveKeys).distinct()
		if (this.drawerProps?.visible) {
			this.handleChange();
		}
	}

	get commonLocales() {
		return CommonLocale;
	}

	get quickViewWindowType() {
		return QuickViewWindowType;
	}

	getRequiredData() {
		if (!this.quickViewProps || !this.quickViewProps.id) {
			return;
		}
		this.setLoading(true);

		if (this.quickViewProps.quickViewType === QuickViewWindowType.Content) {
			QuickViewWindowService.getContentText(this.quickViewProps.id)
				.then((data) => {
					this.contentData = data;
					this.setLoading(false);
				})
				.catch((ex) => {
					this.setLoading(false);
				});
		} else if (this.quickViewProps.quickViewType === QuickViewWindowType.Exposure) {
			QuickViewWindowService.getExposure(this.quickViewProps.id)
				.then((data) => {
					this.exposurData = data;
					this.setLoading(false);
				})
				.catch((ex) => {
					this.setLoading(false);
				});
		}
	}

	setLoading(value: boolean) {
		this.loading = value;
	}

	handleChange() {
		if (!this.quickViewProps || !this.quickViewProps.id) {
			return;
		}

		if (
			isUndefined(this.quickViewProps.id) ||
			isNull(this.quickViewProps.id) ||
			!isGuid(this.quickViewProps.id) ||
			![QuickViewWindowType.Content, QuickViewWindowType.Exposure].includes(this.quickViewProps.quickViewType)
		) {
			MessageHelper.Message(
				NotificationType.Failed,
				fmtMsg(this.commonLocales.CommonHttpArgumentIsNullOrInvalid)
			);
			return;
		}

		this.getRequiredData();
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	onClose(e) {
		if (this.drawerProps && this.drawerProps.close) {
			this.drawerProps.close(e);
		}
	}
}
